/* ORILIS v8 — offer/desire A/B split and simple sliders. By EcomWhy. */
(function () {
  'use strict';

  /* ---------- A/B: each visitor keeps one version ---------- */
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function initAb(root) {
    (root || document).querySelectorAll('[data-o-ab]').forEach(function (box) {
      if (box.hasAttribute('data-ab-show')) return;
      var mode = box.getAttribute('data-o-ab');
      var v = null;
      if (mode === 'offer') v = 'A';
      else if (mode === 'desire') v = 'B';
      else if (mode === 'ab') {
        var forced = (location.search.match(/[?&]ab=([ab])/i) || [])[1];
        var key = box.getAttribute('data-ab-key') || 'orilis_ab';
        v = forced ? forced.toUpperCase() : store(key);
        if (v !== 'A' && v !== 'B') { v = Math.random() < 0.5 ? 'A' : 'B'; }
        if (!forced) store(key, v);
      }
      if (!v) return;
      box.setAttribute('data-ab-show', v);
      if (mode === 'ab') document.documentElement.setAttribute('data-o-ab', v);
    });
  }

  /* ---------- slider: arrows + dots on a scroll-snap track ---------- */
  function initSlide(root) {
    (root || document).querySelectorAll('[data-o-slide]').forEach(function (wrap) {
      if (wrap.dataset.oSlideOn) return; wrap.dataset.oSlideOn = '1';
      var track = wrap.querySelector('[data-o-slide-track]'); if (!track) return;
      var dots = wrap.querySelectorAll('[data-o-slide-dots] > span');
      var rtl = getComputedStyle(track).direction === 'rtl';
      function items() { return Array.prototype.slice.call(track.children); }
      function current() {
        var box = track.getBoundingClientRect(), best = 0, min = Infinity;
        items().forEach(function (el, i) {
          var r = el.getBoundingClientRect();
          var d = rtl ? Math.abs(r.right - box.right) : Math.abs(r.left - box.left);
          if (d < min) { min = d; best = i; }
        });
        return best;
      }
      function go(i) {
        var list = items(); i = Math.max(0, Math.min(list.length - 1, i));
        list[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
      function paint() { var i = current(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); }
      var prev = wrap.querySelector('[data-o-slide-prev]'), next = wrap.querySelector('[data-o-slide-next]');
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
    });
  }

  function initAll(root) { initAb(root); initSlide(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
